export const IS_RUNNING_AS_EXTENSION = !!chrome?.runtime?.id
export const SYNC_CHANNEL_NAME = '1i91je0jsdionsdqwe012'
export const WALLET_BACKUP_KEY = 'BACKUP_WALLET'
export const PASS_KEY = 'PASSWORD'
export const PARA_KEY = 'PASS_PARA'
export const SELECTED_ACCOUNT_KEY = 'SELECTED_ACCOUNT_KEY'
